import React from "react";

function ContractDisplay({ contract = {} }) {
  const {
    contract_id,
    contract_name,
    UKPRN,
    start_date,
    end_date,
    num_learners,
    skill_level,
    summary,
    date_added,
    finance_sign_off,
    finance_sign_off_name,
    management_sign_off,
    management_sign_off_name,
    legal_sign_off,
    legal_sign_off_name,
    comments
  } = contract;

  return (
    <div>
      <h3>{contract_name}</h3>
      <p>{contract_id}</p>
      <p>{UKPRN}</p>
      <p>{start_date}</p>
      <p>{end_date}</p>
      <p>{num_learners}</p>
      <p>{skill_level}</p>
      <p>{summary}</p>
      <p>{date_added}</p>
      <p>{finance_sign_off}</p>
      <p>{finance_sign_off_name}</p>
      <p>{management_sign_off}</p>
      <p>{management_sign_off_name}</p>
      <p>{legal_sign_off}</p>
      <p>{legal_sign_off_name}</p>
      <p>{comments}</p>
    </div>
  );
}

export default ContractDisplay;
